import styled from '@emotion/styled';
import { FC } from 'react';

import NavIconButton from 'app/components/layout/AppLayout/NavIconButton';
import Pulse from 'app/components/v2/animations/Pulse';
import Box from 'app/components/v2/components/Box';
import Jewel from 'app/components/v2/components/Jewel';
import ThreeEvenElements from 'app/components/v2/components/ThreeEvenElements';
import { useGeneralDispatch, useGeneralState } from 'app/state/GeneralContext/hooks';

import AccountMenu from '../DesktopNav/AccountMenu';
import LogoLink from '../LogoLink';
import { NavProps } from '..';

// Local Typings
interface Props extends NavProps {
  hasSomeNotifications: boolean;
}

// Local Variables
export const drawerClassName = 'drawer-toggle';
const StyledPulse = styled(Pulse)({
  pointerEvents: 'none',
  transform: 'translate(-170%, -90%)',
});

// Component Definition
const MobileNav: FC<Props> = ({
  hasSomeNotifications,
  ...props
}) => {
  const generalDispatch = useGeneralDispatch();
  const {
    isSideNavOpen,
  } = useGeneralState();

  function toggleDrawer() {
    generalDispatch({
      type: 'toggleSideNav',
    });
  }

  const isSideNavClosed = !isSideNavOpen;

  return (
    <ThreeEvenElements
      centerElement={(
        <LogoLink
          size="small"
          to={props.logoPath}
          variant="light"
        />
      )}
      leftElement={(
        <Box
          alignItems="center"
          display="flex"
          gap={2}
        >
          <Box
            alignItems="center"
            display="flex"
          >
            <NavIconButton
              buttonColor="icon_button_utility"
              className={drawerClassName}
              iconName={isSideNavClosed ? 'menu' : 'close'}
              // the clickaway listener handles closing the drawer
              // if the user clicks the button, we just let them think the click did something
              // it was actually the clickaway listener that did the work
              // both the key ternary and the onClick ternary are necessary
              key={isSideNavClosed ? 'menu' : 'close'}
              onClick={isSideNavClosed ? toggleDrawer : undefined}
            />

            {hasSomeNotifications && isSideNavClosed && (
              <StyledPulse>
                <Jewel />
              </StyledPulse>
            )}
          </Box>
        </Box>
      )}
      padding={2}
      rightElement={(
        <AccountMenu shouldRenderCompanyName={false} />
      )}
    />
  );
};

export default MobileNav;
